import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validator, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DUMPSTER, SUPPLY, CART_BANANA_BOAT } from '../../../constants/things.constants';
import { ValidatorsService } from '@core/validators/validators.service';

@Component({
  selector: 'resources-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.less']
})
export class ResourcesFilterComponent implements OnInit {

  public form: FormGroup;
  public resources = [
    {
      label: 'Dumpster',
      value: DUMPSTER
    },
    {
      label: 'Supplies',
      value: SUPPLY
    },
    {
      label: 'Trash Cart',
      value: CART_BANANA_BOAT
    }
  ];
  public areas = [];

  @Input()
  public world;
  @Input()
  public property;
  @Input()
  public selectedAreas;
  @Input()
  public selectedResources;

  private defaults: any = {};

  public showHeaderBottomLine: boolean = false;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private validator: ValidatorsService) {}

  ngOnInit() {

    if (! this.property || ! this.property.kingdomId) {
      this.areas = [];
    } else {
      let kingdom = this.world.kingdoms.find(kingdom => kingdom.kingdomId === this.property.kingdomId);
      this.areas = kingdom.lands.filter(land => land.active !== false);
    }

    this.defaults.property = this.property && Object.assign({}, this.property);
    this.defaults.area = this.areas && this.areas.slice(0);
    this.defaults.selectedAreas = this.selectedAreas && this.selectedAreas.slice(0);
    this.defaults.selectedResources = this.selectedResources && this.selectedResources.slice(0);

    this.form = this.fb.group({
      property: [this.property],
      areas: this.fb.group({}),
      resources: this.fb.group({}, {validator: this.validator.atLeastOneChecked})
    });

    if (! this.property) {
      this.form.get('property').setValue(undefined);
    }

    this.updateAreas(this.property);
    this.updateResources();
  }

  onPropertyChange() {
    this.property = this.form.controls['property'].value;
    this.updateAreas(this.property);
  }

  updateAreas(property) {
    this.areas = (property && property.lands && property.lands.filter(area => area.active !== false)) || [];

    let areasFormGroup = {};
    let fgroup = this.form.get('areas') as FormGroup;
    Object.keys(fgroup.controls).map(key => {
      fgroup.removeControl(key);
    });
    this.areas.map(x => {
      let selected = !! (this.selectedAreas && this.selectedAreas.find(area => area === x.areaId));
      fgroup.addControl(x.areaId, new FormControl(selected));
    });

    if(this.areas && this.areas.length > 0) {
      fgroup.setValidators([this.validator.atLeastOneChecked]);
    } else {
      fgroup.setValidators([]);
    }

    fgroup.updateValueAndValidity();
  }

  updateResources() {
    let fgroup = this.form.get('resources') as FormGroup;
    Object.keys(fgroup.controls).map(key => {
      fgroup.removeControl(key);
    });
    this.resources.map(r => {
      let selected = this.selectedResources && this.selectedResources.find(resource => resource === r.value);
      fgroup.addControl(r.value, new FormControl(selected));
    });
  }

  onReset($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.reset();
  }

  reset() {
    this.property = this.defaults.property && Object.assign({}, this.defaults.property);
    this.selectedAreas = this.defaults.selectedAreas && this.defaults.selectedAreas.slice(0);
    this.selectedResources = this.defaults.selectedResources && this.defaults.selectedResources.slice(0);
    this.areas = this.defaults.areas && this.defaults.areas.slice(0);

    this.form.get('property').setValue(this.property);
    this.updateAreas(this.property);
    this.updateResources();
  }

  submitForm(values) {
    this.selectedAreas = [];
    Object.keys(values.areas).map(key => {
      let val = values.areas[key];
      if (val) {
        this.selectedAreas.push(key);
      }
    });
    this.selectedResources = [];
    Object.keys(values.resources).map(key => {
      let val = values.resources[key];
      if (val) {
        this.selectedResources.push(key);
      }
    });

    this.activeModal.close({
      property: this.property,
      selectedAreas: this.selectedAreas,
      selectedResources: this.selectedResources
    });
  }

  propertyTrackBy(index, item) {
    return item.kingdomId;
  }

  hasAreaChecked() {
    let hasChecked = false;
    let fgroup = this.form.get('areas') as FormGroup;
    Object.keys(fgroup.controls).map(key => {
      let control = fgroup.get(key)
      if (control && control.value) {
        hasChecked = true;
      }
    });

    return hasChecked;
  }

  toggleSelectAreas($event) {
    $event.preventDefault();
    $event.stopPropagation();

    let value = this.hasAreaChecked() ? false : true;

    let fgroup = this.form.get('areas') as FormGroup;
    Object.keys(fgroup.controls).map(key => {
      let control = fgroup.get(key);
      control.setValue(value);
    });
  }

  onContentScroll(scrollTop) {
    this.showHeaderBottomLine = (scrollTop > 0);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/resources/filter/filter.component.ts